<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="invoice-server-table"
      class="w-100"
    >
      <div slot="beforeTable" class="pt-3">
        <b-row>
          <b-col>
            <select-filter
              variant="info"
              icon="fa-dollar-sign"
              placeholder="All Paid/Un-Paid"
              :list="filter__paid"
              filter-field="inactive"
              filter-operator="eq"
              @onSelect="setCustomFilter('invoice__paid', $event)"
            ></select-filter>
          </b-col>
          <b-col>
            <select-filter
              variant="info"
              icon="fa-toggle-on"
              placeholder="Credit/No-Credit"
              :list="filter__credit"
              filter-field="credit"
              filter-operator="eq"
              @onSelect="setCustomFilter('invoice__credit', $event)"
            ></select-filter>
          </b-col>
        </b-row>
      </div>
      <span
        v-if="showColumn('created_at')"
        slot="created_at"
        slot-scope="{ row }"
      >
        <router-link v-if="row.created_at" :to="`/orders/${row.id}`"
          ><b>{{ row.created_at | moment("L") }}</b></router-link
        >
      </span>
      <span
        v-if="showColumn('customer.full_name')"
        slot="customer.full_name"
        slot-scope="{ row }"
      >
        <router-link :to="`/customer/${row.getCustomer().id}`"
          ><b>{{ row.getCustomer().name }}</b></router-link
        >
      </span>
      <span
        v-if="showColumn('project.pid')"
        slot="project.pid"
        slot-scope="{ row }"
      >
        <i v-if="loading_projects" class="fa fa-spinner fa-spin text-muted"></i>
        <router-link
          v-if="!loading_projects && project(row.id)"
          :to="`/project/${project(row.id).id}`"
        >
          <b>{{ project(row.id).publicNumber() }}</b>
        </router-link>
      </span>
      <span
        v-if="showColumn('sample_count')"
        slot="sample_count"
        slot-scope="{ row }"
      >
        <i v-if="loading_projects" class="fa fa-spinner fa-spin text-muted"></i>
        <span v-if="!loading_projects && project(row.id)">
          {{ project(row.id).getSamples().models.length }}
        </span>
      </span>
      <span
        v-if="showColumn('product_count')"
        slot="product_count"
        slot-scope="{ row }"
      >
        <span>{{ productsCount(row) }}</span>
      </span>
      <span v-if="showColumn('total')" slot="total" slot-scope="{ row }">
        <span>{{
          `$${Math.abs(row.getInvoiceItems().sum("amount") / 100).toFixed(2)}`
        }}</span>
      </span>
      <span
        v-if="showColumn('payment_succeeded_at')"
        slot="payment_succeeded_at"
        slot-scope="{ row }"
      >
        <span v-if="row.payment_succeeded_at">{{
          row.payment_succeeded_at | moment("L")
        }}</span>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import BaseServerTable from "@/components/shared/BaseServerTable";
import SelectFilter from "@/components/shared/SelectFilter";
import InvoiceCollection from "@/collections/cashier/InvoiceCollection";
import { getCollection } from "@/shared/fetch-utils";

Vue.use(ServerTable);

export default {
  name: "InvoiceServerTable",
  extends: BaseServerTable,
  components: {
    ServerTable,
    SelectFilter
  },
  props: {
    collection: {
      type: Object,
      default: () => new InvoiceCollection()
    },
    show_columns: {
      type: Array,
      default: () => [
        "created_at",
        "customer.full_name",
        "project.pid",
        "sample_count",
        "product_count",
        "total",
        "payment_succeeded_at"
      ]
    },
    filterable: {
      type: Array,
      default: () => ["searchable"]
    },
    sortable: {
      type: Array,
      default: () => ["created_at", "customer.full_name"]
    }
  },
  data() {
    return {
      customer_id: this.$route.params.customer_id || null,
      table_config: this.lodash.merge(this.getDefaultTableConfig(), {
        options: {
          headings: {
            created_at: "Created On",
            "customer.full_name": "Customer",
            "project.pid": "Project",
            sample_count: "Samples",
            product_count: "Products",
            total: "Total(CAD)",
            payment_succeeded_at: "Paid On"
          },
          filterable: this.filterable,
          sortable: this.sortable
        }
      }),
      projects: null,
      loading_projects: true,
      filter__paid: [],
      filter__credit: []
    };
  },
  computed: {
    project() {
      let projects = this.projects;

      return invoice_id => {
        let project = null;

        if (projects) {
          project = projects.find(project => project.invoice_id === invoice_id);
        }
        return project;
      };
    }
  },

  methods: {
    prepareCollectionFilter(filter) {
      filter.sortAddDesc("created_at", true);

      this.customer_id && filter.filterEquals("customer_id", this.customer_id);

      return filter;
    },
    productsCount(invoice) {
      return (
        invoice
          .getInvoiceItems()
          .models.filter(item => item.metadata && item.metadata.product_id)
          .length || null
      );
    },
    async onFetchSuccess(collection) {
      this.loading_projects = true;

      this.projects = await getCollection({
        collection_type: "project",
        filters: [
          {
            logic: "filterIn",
            field: "invoice_id",
            value: collection.models.map(({ id }) => id)
          }
        ]
      });

      this.loading_projects = false;
    }
  }
};
</script>
